var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VehiclesHeader',{attrs:{"title":"Nuevo Vehículo"}}),_c('hr'),_c('VehiclesForm',{attrs:{"vehicle":_vm.vehicle},on:{"onCreate":_vm.onCreate}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }